module.exports = __webpack_public_path__ + "static/media/penguin_astronaut.c478eac5.png";